export const randomIdGenerator = (suffix: string = 'item', length: number = 1e9) => `${ suffix }-${ Math.floor(Math.random() * length).toString(16) }`;